import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';


const Chevron = (props) => {
  const { direction, size, width, top, left } = props;
  let classes = styles.chevron;
  if (direction.length) {
    if (direction === 'left') {
      classes += ` ${styles.left}`;
    } else if (direction === 'down') {
      classes += ` ${styles.down}`;
    } else if (direction === 'right') {
      classes += ` ${styles.right}`;
    }
  }
  const chevronStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };
  if (top) {
    chevronStyle.top = `${top}px`;
  }
  if (left) {
    chevronStyle.left = `${left}px`;
  }
  if (width) {
    chevronStyle.borderWidth = `${width}px ${width}px 0px 0px`;
  }
  return (
    <span className={classes} style={chevronStyle}>
      &nbsp;
    </span>
  );
};

Chevron.propTypes = {
  size: PropTypes.number,
  width: PropTypes.number,
  direction: PropTypes.string,
  top: PropTypes.number,
  left: PropTypes.number,
};

Chevron.defaultProps = {
  size: 15,
  width: 3,
  direction: '',
  top: null,
  left: null,
};

export default Chevron;
